import { STATES_MAP } from '@repo/supergraph/marketplace/constants';

export const STATE_OPTIONS = Object.entries(STATES_MAP).map(([abbreviation, name]) => ({
  label: name,
  value: abbreviation,
}));

export const DEFAULT_STATE_OPTION = 'CA';
